<template>
    <div id="why-us">
        <section id="why-us-section">
            <div class="container-fluid">
                <div class="row justify-content-center text-center">
                    <div class="col-10 m-auto">
                        <h2 class="section-title">Why Is SPIRITT the Right Choice?</h2>
                        <p class="text-center sub-title rtl">An All-In-One Boutique App for High-Standard Entrepreneurs</p>
                        <div class="row text-left direction-ltr">
                            <div class="col-12 col-md-6 media order-1 order-md-1 mb-4" data-aos="fade-up" data-aos-duration="1200">
                                <div class="logo">
                                    <img src="/img/why-us/cross-platform.svg" alt="cross-platform" class="align-self-start">
                                </div>
                                <div class="col-10">
                                    <p class="h5">Three in One. Always.</p>
                                    <p>As the number of your channels rises, so does your chances to succeed.
                                        Why, in 2020, should you compromising on one channel? With SPIRITT, every app automatically has <span class="strong">web, android, and ios</span> versions.</p>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 media order-2 order-md-2 mb-4" data-aos="fade-up" data-aos-duration="1200">
                                <div class="logo">
                                    <img src="/img/why-us/aws.svg" alt="aws servers" class="align-self-start">
                                </div>
                                <div class="col-10">
                                    <p class="h5">Focus on Growth</p>
                                    <p>Start-up is the only thing that can scale exponentially in a night.
                                        Manage servers can be damn hard, but with SPIRITT, you get your app packed and <span class="strong">hosted</span> on an AWS based server that is <span class="strong">ready for any scale</span>, any time.</p>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 media order-3 order-md-4 mb-4" data-aos="fade-up" data-aos-duration="1200">
                                <div class="logo">
                                    <img src="/img/why-us/speed.svg" alt="fast applications and websites" class="align-self-start">
                                </div>
                                <div class="col-10">
                                    <p class="h5">Speed, Speed, Speed.</p>
                                    <p>Every 1ms that your app is loading costs you in a loss of users and revenues. With SPIRITT, your app is <span class="strong">extremely fast</span>, thanks to the use of unique technology. Yes, on the web version as well.</p>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 media order-4 order-md-3 mb-4" data-aos="fade-up" data-aos-duration="1200">
                                <div class="logo">
                                    <img src="/img/why-us/seo.svg" alt="seo" class="align-self-start">
                                </div>
                                <div class="col-10">
                                    <p class="h5">Finding You Is Easy.</p>
                                    <p>Ok, so your startup is terrific, but can people find you?
                                        SPIRITT optimizes every piece of your app for <span class="strong">SEO</span>.
                                        We optimize meta-data, Schema.org, URL's, and many more.</p>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 media order-5 order-md-5 mb-4" data-aos="fade-up" data-aos-duration="1200">
                                <div class="logo">
                                    <img src="/img/why-us/no-risk.svg" alt="no risk" class="align-self-start">
                                </div>
                                <div class="col-10">
                                    <p class="h5">Reduce Your Risk.</p>
                                    <p>With SPIRITT, you can launch your app way faster than any other option.
                                        And, you get a <span class="strong">free 7 days trial</span> that starts only after your app launching. Pay as you grow, and only after you know you like your app.
                                    </p>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 media order-6 order-md-6 mb-4" data-aos="fade-up" data-aos-duration="1200">
                                <div class="logo">
                                    <img src="/img/why-us/design.svg" alt="best design" class="align-self-start">
                                </div>
                                <div class="col-10">
                                    <p class="h5">Design First</p>
                                    <p>As you can see by our page, we care about design. We think that great ideas should have a greater package. That is why every spiritt app will get
                                        <span class="strong">a pro-designer touch</span>, without any additional fee.</p>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 media order-7 order-md-8 mb-4" data-aos="fade-up" data-aos-duration="1200">
                                <div class="logo">
                                    <img src="/img/why-us/secure.svg" alt="secure app" class="align-self-start">
                                </div>
                                <div class="col-10">
                                    <p class="h5">Keep Your App Secure</p>
                                    <p>With SPIRITT, we take care of using SSL, encrypt your data, and use an AWS-based cloud to keep your app <span class="strong">security</span> with high standard. We also take care of making your app ready to be a <span class="strong">GDPR compliant.</span></p>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 media order-8 order-md-7 mb-4" data-aos="fade-up" data-aos-duration="1200">
                                <div class="logo">
                                    <img src="/img/why-us/vc.svg" alt="application vc love" class="align-self-start">
                                </div>
                                <div class="col-10">
                                    <p class="h5">VC Read</p>
                                    <p>We know that most start-Ups aim to raise money for faster growth, and we also know that VC's care about IP. That is why we've created legal terms that promise you to <span class="strong">keep your IP</span> yours: Your data, customers, API, etc.</p>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 media order-9 order-md-9 mb-4" data-aos="fade-up" data-aos-duration="1200">
                                <div class="logo">
                                    <img src="/img/why-us/monetization.svg" alt="monetization" class="align-self-start">
                                </div>
                                <div class="col-10">
                                    <p class="h5">Monetization Included</p>
                                    <p>SPIRITT enables you to establish the business model you've always dreamed of, right away. You can <span class="strong">charge money</span> within your app in different ways. And also, you can <span class="strong">embed ads</span> in your app if this is your business model.</p>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 media order-10 order-md-10 mb-4" data-aos="fade-up" data-aos-duration="1200">
                                <div class="logo">
                                    <img src="/img/why-us/analytic.svg" alt="app analytic" class="align-self-start">
                                </div>
                                <div class="col-10">
                                    <p class="h5">Be in Control</p>
                                    <p>A good start-up lives in harmony and love with the data and the numbers of its app. SPIRITT enables you to integrate with every amazing <span class="strong">analytic tool</span> out there. By that, you can be in an infinite loop of <span class="strong">learning and improving</span>.</p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 media my-5 insperation-block" data-aos="fade-up" data-aos-duration="1200">
                                <div class="col-3 col-md-2 h-100">
                                    <img src="/img/why-us/spiritt-icon.svg" alt="spiritt apps" class="img-fluid align-self-center">
                                </div>
                                <div class="col-9 col-md-6">
                                    <p class="h5 text-left">"The People Who Are Crazy Enough to Think They Can Change the World Are the Ones Who Do." - S. Jobs</p>
                                </div>
                                <div class="col-12 col-md-4 h-100"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import { Carousel, Slide } from 'vue-carousel';

    export default {
        name: 'partners',
        data () {
          return {
              partners: [
                    {image: 'img/why-us/cross-platform.svg', title: 'Three In One. Always.', content:`As The Number Of Your Channels Rises, So Does Your Chances To Succeed. \n Why, In 2020, Should You Compromising On One Channel? With SPIRITT, Every App Automatically Has Web, Android, And IOS Versions.`},
                    {image: 'img/why-us/cross-platform.svg', title: 'Successful companies'},
                    {image: 'img/why-us/cross-platform.svg', title: 'Revolutionary Start-ups'},
                    {image: 'img/why-us/cross-platform.svg', title: 'Revolutionary Start-ups'},
                    {image: 'img/why-us/cross-platform.svg', title: 'Successful companies'},
                    {image: 'img/why-us/cross-platform.svg', title: 'Revolutionary Start-ups'},
                    {image: 'img/why-us/cross-platform.svg', title: 'Revolutionary Start-ups'},
              ],
          }
        },
        components: {
            Carousel,
            Slide,
        },
    }
</script>

<style lang="css" scoped>
    #why-us {
        background-color: #fff;
        color: #000000;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    .section-title {
        font-size: 45px;
        font-weight: 300;
        line-height: 1;
        width: 100%;
        display: block;
        text-align: center;
    }
    .strong{
        font-weight: 400;
    }
    .sub-title {
        font-size: 20px;
        margin-bottom: 50px;
    }
    .logo {
        margin-top: .5rem;
        margin-right: .75rem;
        width: 6rem;
        text-align: center;
    }
    .insperation-block{
        border-radius: 32px;
        background-color: #000;
        color: #fff;
        height: 205px;
    }
    .logo img {
        width: 60px;
    }

    @media (max-width: 767px) {
        .section-title {
            font-size: 30px;
        }
        .sub-title {
            font-size: 18px;
        }
    }
</style>
